(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RaceDetailController', RaceDetailController);

    RaceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Race', 'Patient', 'Corporation'];

    function RaceDetailController($scope, $rootScope, $stateParams, previousState, entity, Race, Patient, Corporation) {
        var vm = this;

        vm.race = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:raceUpdate', function(event, result) {
            vm.race = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
